<template>
  <DelDialog
    width="480px"
    :dialogVisible="visible"
    @handleClose="handleCancel"
    @handleConfirm="handleConfirm"
  >
    <template #title>{{$t('newProjectV2.createPunctuateRule')}}</template>
    <el-form :rules="rules" ref="form" class="createRule" :model="form">
        <el-form-item :label="$t('newProjectV2.punctuateType')" prop="type">
          <el-radio-group v-model="form.type" @change="handleChangeType">
            <el-radio label="0">{{$t('newProjectV2.configPunctuateRule')}}</el-radio>
            <el-radio label="1">{{$t('newProjectV2.uploadPunctuateRule')}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="$t('newProjectV2.name')" prop="ruleName">
          <el-input
            maxlength="8"
            v-model.trim="form.ruleName"
            :placeholder="$t('newProjectV2.punctuateRuleNameTip')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('newProjectV2.language')" prop="langCode">
          <el-select v-model="form.langCode" :placeholder="$t('newProjectV2.punctuateRuleLangTip')">
            <el-option
              v-for="item in language"
              :label="$i18n.locale === 'zh' ? item.name : $langCase[item.code]"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
        </el-select>
        </el-form-item>

        <el-form-item class="file-form-item" required :label="$t('newProjectV2.upload')" prop="file" v-if="parseInt(form.type)===1">
          <el-upload
            drag
            action
            multiple
            :limit="1"
            accept=".xlsx"
            class="upload-area"
            :file-list="fileList"
            :show-file-list="false"
            :on-exceed="handleExceed"
            :on-change="uploadChange"
            :before-upload="beforeUploadFile"
            :http-request="uploadSectionFile"
          >

            <div class="emptyBox" v-if="fileList.length ? false: true">
              <div class="el-upload__text">
                {{$t('newProjectV2.clickOrDragUpload')}}
                <em style="display:block">{{$t('newProjectV2.onlySupportFormate', ['xlsx'])}}</em>
              </div>
            </div>
            <div v-else class="file-upload-list">
              <div class="file-item" v-for="(item, index) in fileList" :key="index">
                <div class="file-top">
                  <el-tooltip effect="dark" :content="item.name" placement="top">
                    <span class="file-name">{{item.name}}</span>
                  </el-tooltip>
                </div>
                <div class="file-bottom">
                  <div class="progress"><el-progress :percentage="isNaN(item.percentage) ? 100 : item.percentage"></el-progress></div>
                  <div class="del" @click.stop="handleDelete(index)"></div>
                </div>
              </div>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import axios from "axios";
import { apiRoot } from '@/services/ajax';
import { getUploadSign } from '@/services/newProjectApi';
import { queryAllExistLang, queryAllLang, insertPunctuateRule } from '@/services/dialogApi';

export default {
  name: 'createPunctuateRules',
  props: {
    visible: {
      type: Boolean,
      require: true,
    }
  },
  components: {
    DelDialog
  },
  data () {
    return {
      downloadTemplateUrl: apiRoot('/transSegmentRule/downloadTemplate'),
      rules: {
        ruleName: [
          { required: true, message: this.$t('newProjectV2.punctuateRuleNameTip'), trigger: 'blur' }
        ],
        langCode: [
          { required: true, message: this.$t('newProjectV2.languageTip'), trigger: 'change' }
        ],
        file: [
          { required: true, message: this.$t('newProjectV2.selUploadFileTip'), trigger: 'change' }
        ]
      },
      form: {
        type: '0',
        ruleName: '',
        langCode: '',
        file: ''
      },
      language: [],
      langCodeMap: new Map(),
      fileList: [],
      fileName: ''
    }
  },
  mounted () {
    this.getLanguage();
    // this.getExistLangCode();
  },
  methods: {
    handleCancel () {
      this.$refs['form'].resetFields();
      this.fileList = [];
      this.$emit('handleCancel');
    },
    handleConfirm () {
      let self = this;
      self.$refs['form'].validate((valid) => {
        if (valid) {
          (self.language).map((item) => {
            if ((item.code) === (self.form.langCode)) {
              Reflect.set((self.form), 'langName', (item.name))
            }
          });

          let param = {
            fileName: self.fileName,
            langCode: self.form.langCode,
            langName: self.form.langName,
            ruleName: self.form.ruleName
          }

          insertPunctuateRule(param).then(resp => {
            if (resp.success) {
              self.$message.closeAll();
              self.$message({
                message: this.$t('newProjectV2.createSuccess'),
                type: "success"
              });
              self.handleCancel();
              self.getExistLangCode();
              self.$emit('updateRule');
            }
            // else {
            //   self.$message.closeAll();
            //   self.$message({
            //     message: resp.errorDesc,
            //     type: "error"
            //   });
            //   return false;
            // }
          });
        } else {
          return false;
        }
      });
    },
    handleChangeType (val) {
      this.$refs['form'].resetFields();
      this.fileList = [];
      this.fileName = '',
      this.form.type = val;
    },
    //获取焦点获取能选择的语种
    getExistLangCode: function () {
      const self = this;
      queryAllExistLang({}).then((resp) => {
        if (resp.success) {
          let result = resp.result;
          result.map((item) => {
              (self.langCodeMap).set((item.langCode), (item.langName));
          });
          self.getLanguage();
        } else {
          self.$message.closeAll();
            self.$message({
              message: resp.errorDesc,
              type: "error"
            });
            return false;
          }
      });
    },
    getLanguage () {
      const self = this;
      queryAllLang({}).then((resp) => {
        if (resp.success) {
          // (resp.result).map((item)=>{
          //   item.disabled = [...(self.langCodeMap).keys()].includes(item.code);
          // });

          self.language = (resp.result);
        }
      });
    },
    handleDelete (index) {
      this.form.file = ''
      this.fileList.splice(index, 1);
    },
    uploadSectionFile (param) {
      let self = this;
      let file = param.file;

      let re = /([^\.\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();

      getUploadSign({}).then(({ result }) => {
        self.host = result.host;

        let para = {
          ...result,
          key : `${result.keyPrefix}.${type}`,
          file: param.file,
        };
        Reflect.deleteProperty(para, 'keyPrefix');
        Reflect.deleteProperty(para, 'host');

        self.formData = new FormData();
        Object.keys(para).forEach(function (key) {
          self.formData.append(key, para[key]);
        });

        self.getFileHost(param);
      })
    },
    getFileHost (param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: progressEvent => {
          const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({percent: complete});
        }
      };

      axios.post(FileController, self.formData, config).then((resp) => {
        let { result, success } = resp.data;
        if (!success) {
          return;
        }
        self.fileName = result.fileName;
      });
    },
    uploadChange (file) {
      this.fileList.push({
        ...file
      });
      this.form.file = this.fileList.length;
    },
    handleExceed () {
      this.$message.closeAll();
      this.$message({
        message: this.$t('newProjectV2.onlyUploadOneFile'),
        type: 'warning'
      });
    },
    beforeUploadFile (file) {
      let re = /([^\.\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();

      let typeFlag = type === "xlsx";

      if (!typeFlag) {
        this.$message.closeAll();
        this.$message({
          message: this.$t('newProjectV2.onlySupportFormate', ['xlsx']),
          type: "warning"
        });
        // 去除最后一个文件
        this.fileList.pop();
        return false;
      }
      return true;
    },
  },
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>